import { getNextParentElement } from "../../../../common/utils/getNextParentElement";

/**
 *
 *
 *
 *
 */
const findNearestTransformParent = (el: HTMLElement): HTMLElement | undefined => {
  let parent = getNextParentElement(el) ?? undefined;

  while (parent && parent !== document.body) {
    const style = window.getComputedStyle(parent);

    /*                                                     */
    if (
      style.transform !== "none" ||
      style.filter !== "none" ||
      style.perspective !== "none" ||
      style.backdropFilter !== "none" || /*                                */
      style.willChange === "transform" || /*                                 */
      style.willChange === "filter"
    ) {
      return parent;
    }

    parent = getNextParentElement(parent) ?? undefined;
  }

  /*                                             */
  return undefined;
};

/**
 *
 *
 *
 *
 */
export const calculateSnackbarAdditionalSpacing = (
  snackbarEl: HTMLElement,
): { bottom: number; left: number } => {
  const container = findNearestTransformParent(snackbarEl);

  /*                                      */
  /*                                         */
  if (!container) return { bottom: 0, left: 0 };

  /*                                                    */
  /*                                       */

  /*                        */
  const vh = window.innerHeight;

  /*                                           */
  const containerRect = container.getBoundingClientRect();

  /*                                                                      */
  /*                                 */
  const newBottom = containerRect.bottom - vh;
  const newLeft = -containerRect.left;

  return { bottom: newBottom, left: newLeft };
};
